module.exports = __webpack_public_path__ + "static/media/fanicon.c7e13453.svg";